const eliminarPrestacionFormState = {
  dupsMsg: "",
  aceptaGuardadoModal: false,
  aceptaGuardadoModalEliminacion: false,
  vigenciaPrestacionEliminacion: null,
  vigenciaPrestacionEliminacionError: "",
  centrosAtencionPrestacion: [],
  detallePrestacion: {
    codigoPrestacionPrestador: "",
    pabellonPrestacion: "",
    glosaPrestacionPrestador: "",
    codigoFonasa: "",
    grupoPrestacionIsapre: "",
    grupoPrestacionPrestador: "",
    codigoPrestacionIsapre: "",
    glosaPrestacionIsapre: "",
    codigoProfesional: "",
    montoArancelPrestacion: "",
    unidadArancelPrestacion: "",
    inicioVigenciaArancelPrev: null,
    tipoAtencion: "",
    itemImed: "",
    glosagGupoPrestacionIsapre: "",
    IdPrestacion: 0,
  },
  loadingArbolDetalle: false,
};

export default eliminarPrestacionFormState;




// WEBPACK FOOTER //
// ./src/components/ActualizarArancel/EliminarPrestacionForm/state.js